<template>
  <div>
    <DeleteModal
      v-if="showDeleteModal"
      @close-delete-modal="showDeleteModal = !showDeleteModal"
      @deleteItem="deleteEvent"
      @cancelDeleteProcess="cancelDeleteProcess"
      itemType="Event"
      />
    <EventModal
      v-if="showModal"
      @close-modal="showModal = !showModal"
      @save="save"
      @hideModal="showModal = !showModal"
      :eventObject="eventObject"
       />
    <div class="flex justify-between items-center py-4">
      <h2
        class="text-blueGray-700 text-lg font-semibold">
        Evento
      </h2>
      <button
        @click="openModal"
        class="bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded">Add Evento</button>
    </div>
    <div class="app-block mb-22 shadow-lg">
      <div class="">
          <ul>
            <li 
              v-for="(event, idx) in eventList"
              :key="idx"
              class="flex justify-between pt-4 pb-4">
              <div class="">
                <h2
                  v-html="event.title"
                  class="text-lg font-semibold">
                </h2>
                <span
                  v-html="(event.date)"
                  class="text-sm">
                </span>
              </div>
              <div class="flex justify-between">
                <span>
                  <i
                    @click="edit(event._id)"
                    class="fas fa-pencil-alt cursor-pointer"></i>
                </span>
                <span>
                  <i
                    @click="showDeleteEventModal(event._id)"
                    class="fas fa-trash-alt ml-4 cursor-pointer"></i>
                </span>
              </div>
            </li>
          </ul>
      </div>
    </div>
  </div>
</template>

<script>
import EventModal from '@/components/modals/EventModal';
import DeleteModal from '@/components/modals/DeleteModal';
import { ToastSuccess, ToastError } from '../utils/Swal'
import FirebaseStorage from '../utils/fileUpload'
import { mapStores } from 'pinia'
import { useGeneralStore } from '@/stores/index.js'
import axios from 'axios'

export default {
  components: {
    EventModal,
    DeleteModal
  },

  data() {
    return {
      eventObject: {},
      eventList: [],
      showModal: false,
      showDeleteModal: false,
      idOfItemToDelete: null,
      generalStore: useGeneralStore(),
      eventObjectToSave: {},
      firebaseStorage: new FirebaseStorage()
    }
  },

   computed: {
    ...mapStores(useGeneralStore)
  },

  methods: {

    openModal() {
      this.eventObject = {}
      this.showModal = !this.showModal
    },

    async save(object) {
      this.eventObjectToSave = object

      if (object.file !== null) {
        if (this.eventObjectToSave.queryMode === 'new') {
          await this.saveFileInStorage()
        } else if (this.eventObjectToSave.queryMode === 'edit') {
          await this.editFileInStorage()
        }
        this.databaseHandler()
      } else {
        this.databaseHandler()
      }
    },

    async databaseHandler() {
      try {
        const { data: response } = await axios.post(`${process.env.VUE_APP_DOMAIN_NAME}/api/admin/${this.eventObjectToSave.queryMode}-event`, 
          this.eventObjectToSave.form,
          { withCredentials: true })
      
        if (response.saved) {
          ToastSuccess.fire({
            title: `<p style="color: #fff";>${response.message}</p>`
          })

          if (this.eventObjectToSave.queryMode === 'new') {
            this.generalStore.setNewEvent(response.doc)
          } else if (this.eventObjectToSave.queryMode === 'edit') {
            this.generalStore.editEvent(response.doc)
            this.refreshList()
          }
        }
      } catch (error) {
        if (error.response) {
          ToastError.fire({
            title: `<p style="color: #fff";>${error.response.data.message}</p>`
          })
        } else {
          console.log(error);
        }
      }
    },

    async saveFileInStorage() {
      let uniqueId = Date.now().toString(36) + Math.random().toString(36).substring(2);
      this.eventObjectToSave.form.filePath = `${this.eventObjectToSave.path}/${uniqueId}/`

      const payload = await this.firebaseStorage.save({
        file: this.eventObjectToSave.file,
        path: this.eventObjectToSave.form.filePath
      })

      this.eventObjectToSave.form.filename = payload.file.name
      this.eventObjectToSave.form.downloadURL = payload.file.downloadURL
    },

    async editFileInStorage() {
      const payload = await this.firebaseStorage.edit({
        file: this.eventObjectToSave.file,
        previousFilename: this.eventObjectToSave.form.filename,
        path: this.eventObjectToSave.form.filePath
      })
          
      this.eventObjectToSave.form.filename = payload.file.name
      this.eventObjectToSave.form.downloadURL = payload.file.downloadURL
    },
    
    edit(id) {
      this.eventObject = this.eventList.find(event => event._id === id)
      this.showModal = !this.showModal
    },

    cancelDeleteProcess() {
      this.idOfItemToDelete = null
      this.showDeleteModal = false
    },

    async deleteEvent() {
      try {
        const { data: response } = await axios.post(`${process.env.VUE_APP_DOMAIN_NAME}/api/admin/delete-event`,
        { id: this.idOfItemToDelete },
        { withCredentials: true })

        if (response.deleted) {
          this.firebaseStorage.delete({
            path: response.doc.filePath,
            previousFilename: response.doc.filename
          })

          this.generalStore.deleteEvent(this.idOfItemToDelete)
          this.idOfItemToDelete = null
          this.refreshList()
          this.showDeleteModal = false
        }
      } catch (error) {
        if (error.response) {
          ToastError.fire({
            title: `<p style="color: #fff";>${error.response.data.message}</p>`
          })
        } else {
          console.log(error);
        }
      }
    },

    showDeleteEventModal(id) {
      this.idOfItemToDelete = id
      this.showDeleteModal = true
    },
    
    refreshList() {
      this.eventList = this.$store.state.events
    }
  },

  async mounted() {
    try {
      const { data: response } = await axios.post(`${process.env.VUE_APP_DOMAIN_NAME}/api/admin/get-events`, {},
      { withCredentials: true })
      if (response.doc) {
        this.generalStore.loadEvents(response.doc)
        this.eventList = this.generalStore.events
      }
    } catch (error) {
      if (error.response) {
        ToastError.fire({
          title: `<p style="color: #fff";>${error.response.data.message}</p>`
        })
      } else {
        console.log(error);
      }
    }
  }
}
</script>

<style scoped>

  ul li {
    border-top: 1px solid grey;
  }

  ul li:first-child {
    border-top: 0px solid grey;
  }
</style>